<template>
  <div id="newsTable">
      <div v-if="data">
      <h1 align="center">News</h1>
      <div class="cardbox">
          <div v-for="item in data" v-bind:key="item.url" class="card">
              <!-- {{ item.url | checkhttps}}
              {{ item.image | checkhttps}} -->
              <a v-bind:href="item.url">
                  <img  v-bind:src="item.image" class="cardimage">
              </a>
              <div class="cardtext">
                <div class="title">
                    <a v-bind:href="item.url"> {{ item.headline }} </a>
                </div>
                <div class="subtitle">
                    <a> {{ item.source }} </a>
                </div>
                <div class="summary">
                    <a> {{ item.summary }} </a>
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
// import VueApexCharts from 'vue-apexcharts';


export default {
  name: 'NewsComponent',
  props: ['ticker'],
  data() {
    return {
        // ticker: 'AAPL',
        data: null,
    }
  },
  // computed: {},
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      let params = {
        'ticker':this.ticker,
      }
      await axios
        // .get('http://127.0.0.1:5000/api/news', {params:params})
        .get(`${process.env.VUE_APP_DATA_API_HOST}/news`, {params:params})
        .then(response => {
          this.data = response.data['data']
          // console.log(this.data)
        })
        .catch(e => {
          e
        })
    },
  },
  filters: {
    checkhttps: function (url) {
      // var pattern = new RegExp('https://')
      var tmp = url;
      // console.log(tmp)
      if (tmp.indexOf("https:") == 0){
        return true
      } else {
        return false
      }
    },
  },
  watch:{
    ticker:function(){
      this.fetchData()
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* css source: https://stocknewsapi.com/ */
.cardbox {
    border: 1px solid #C6CDD5;
    background-color: #FFF;
    width: 100%;
    margin: 20px auto;
    position: relative;
    height: 400px;
    overflow: auto;
    overflow-x: hidden;
    display:inline-block;
}
.card {
    width: 100%;
    height: 25%;
    margin: 0px auto;
    position: relative;
    display: inline-block;
    overflow: hidden;
    overflow-y: hidden;
    /* margin-bottom: 1.5rem; */
}
.cardimage {
    width: 20%;
    height: 100%;
    float: left;
    padding: 0.25rem;
    position: relative;
    z-index: 10;
    vertical-align: center;
}
.cardtext{
  vertical-align: center;
  padding: 0.25rem;
}
.title{
    line-height: 1.5rem;
    color: #000000;
    white-space: nowrap;
    overflow: hidden;
    overflow-x: hidden;
    overflow-y: hidden;
    text-overflow: ellipsis;
    font-size: 1.25rem;
    position: relative;
    text-align: left;
}
.subtitle{
    line-height: 1.5rem;
    color: #737373;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1rem;
    position: relative;
    text-align: left;
}
.summary {
  overflow: hidden;
  overflow-y: auto;
  text-align: left;
  font-size: 0.75rem;
  /* white-space: nowrap; */
}


</style>